<template>

    <div class="width-100-p">

      <el-row class="m-0">
        <el-col :span="24">
            <div class="custom-steps d-flex align-center justify-center">
                <!-- Step 1: Current -->
                <div class="custom-step" >
                    <div class="step-icon">
                        <svg class="width-60 height-60 svg-vertical-centered">
                            <use href="@/assets/svg/newSvgIcon.svg#history_card_current"></use>
                        </svg>
                    </div>
                </div>
                
                <!-- Connecting line 1 -->
                <div class="step-line" >
                    <div class="custom-line"></div>
                </div>
                
                <!-- Step 2: Under audit -->
                <div class="custom-step" >
                    <div class="step-icon">
                        <svg class="width-60 height-60 svg-vertical-centered">
                            <use href="@/assets/svg/newSvgIcon.svg#history_card_under_audit"></use>
                        </svg>
                    </div>
                </div>
                
                <!-- Connecting line 2 -->
                <div class="step-line" >
                    <div class="custom-line"></div>
                </div>
                
                <!-- Step 3: Issue requested -->
                <div class="custom-step" >
                    <div class="step-icon">
                        <svg class="width-60 height-60 svg-vertical-centered">
                            <use href="@/assets/svg/newSvgIcon.svg#history_card_issue_requested"></use>
                        </svg>
                    </div>
                </div>
            </div>
        </el-col>

        <el-col :span="24">
            <div class="custom-steps d-flex align-center justify-center" style="gap: 100px;">
                <!-- Step 1: Current -->
                <div class="custom-step-data">
                    <div class="step-content">
                        <span class="moderat-white-12 mb-1">{{ cardData.current.title }}</span>
                        <p class="moderat-white-bold-22 mb-0">{{ cardData.current.value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
                    </div>
                </div>

                <!-- Step 2: Under audit -->
                <div class="custom-step-data">
                    <div class="step-content">
                        <span class="moderat-white-12 mb-1">{{ cardData.under_audit.title }}</span>
                        <p class="moderat-white-bold-22 mb-0">{{ cardData.under_audit.value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
                    </div>
                </div>
                
                <!-- Step 3: Issue requested -->
                <div class="custom-step-data">
                    <div class="step-content">
                        <span class="moderat-white-12 mb-1">{{ cardData.issue_requested.title }}</span>
                        <p class="moderat-white-bold-22 mb-0">{{ cardData.issue_requested.value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
                    </div>
                </div>
            </div>
        </el-col>
  
      </el-row>
    </div>  
  </template>
  
  <script>
  export default {
    props: {
      dataProp: {
        type: Array,
        default(rawProps) {
          return rawProps;
        },
      },
    },
    components: {
      // ShowDetail,
    },
    data() {
      return {
        show: true,
        cardData: {
          current: { title: "Current", value: 0 },
          under_audit: { title: "Under audit", value: 0 },
          issue_requested: { title: "Issue requested", value: 0 },
        },

      };
    },
    computed: {
    },
    watch: {
      dataProp: {
        handler: function (newValue) {
          console.log("newValue", newValue);
          this.cardData.current.value = newValue.current;
          this.cardData.under_audit.value = newValue.under_audit;
          this.cardData.issue_requested.value = newValue.issue_requested;
        },
        deep: true,
      },
    },
    methods: {},
  };
  </script>
  
  <style scoped>
  .svg-vertical-centered {
    padding-top: 4px;
    padding-bottom: 4px;
    width: 80px;
    height: 80px;
    overflow: visible;
  }
  
  /* Custom Steps Styling */
  .custom-steps {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px 0;
    width: 100%;
    gap: 6px;
  }
  
  .custom-step {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    flex: 1;
    max-width: 20%;
  }

  .custom-step-data {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    flex: 1;
    max-width: 30%;
  }
  
  .step-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    margin-bottom: 10px;
  }
  
  .step-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  
  .step-line {
    min-width: 20%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    position: relative;
    flex: 0 0 20px;
  }
  
  .custom-line {
    height: 1px;
    background-color: #78BE20;
    width: 100%;
    position: absolute;
    top: 25%;
    left: 0;
    transform: translateY(-50%);
  }

  </style>
  